export default "__VITE_ASSET__BkgXlDjq__"